import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../calculateDerAction';

import fetchApi from './fetchApi';

function fetchCalculateDerAction(speciesId,
                                 breedId,
                                 birth,
                                 isMale,
                                 sterilisedId,
                                 pregnancyId,
                                 lactationId,
                                 litterSize,
                                 currentBodyWeight,
                                 goalWeight,
                                 bodyConditionScore,
                                 isWeightAdjustment,
                                 durationId,
                                 intensityFieldId,
                                 environmentTemperature,
                                 diagnoses,
                                 isCriticalCare,
                                 products) {

  return fetchApi(
    '/v1/fc_api/calculate_der_resource' +
      '?speciesId=' + speciesId +
      '&breedId=' + breedId +
      '&birth=' + birth +
      '&isMale=' + isMale +
      '&sterilisedId=' + sterilisedId +
      '&pregnancyId=' + pregnancyId +
      '&lactationId=' + lactationId +
      '&litterSize=' + litterSize +
      '&currentBodyWeight=' + currentBodyWeight +
      '&goalWeight=' + goalWeight +
      '&bodyConditionScore=' + bodyConditionScore +
      '&isWeightAdjustment=' + isWeightAdjustment +
      '&durationId=' + durationId +
      '&intensityFieldId=' + intensityFieldId +
      '&environmentTemperature=' + environmentTemperature +
      '&diagnoses=' + diagnoses +
      '&isCriticalCare=' + isCriticalCare +
      '&products=' + products,
    fetchDataPending,
    fetchDataSuccess,
    fetchDataError)
}

export default fetchCalculateDerAction;
